<div class="flex items-start justify-between gap-2">
    <div class="text-[15px] font-semibold leading-[22px]" data-testid="global-editor-menu-container-title">
        {{ 'common.editor.insert-link' | translate }}
    </div>
    <sh-button
        class="shrink-0"
        data-testid="global-editor-menu-button-close"
        icon="cancel"
        layout="normal"
        color="tertiary"
        size="s"
        (click)="close($event)"
    ></sh-button>
</div>

<sh-input-text
    class="block w-full"
    data-testid="global-editor-menu-input-text"
    [label]="'common.editor.link-text' | translate"
    [formControl]="linkTextControl"
></sh-input-text>

<sh-input-text
    data-sh-editor-link-url="true"
    class="block w-full"
    data-testid="global-editor-menu-input-url"
    [label]="'common.editor.insert-url' | translate"
    placeholder="https://"
    [formControl]="linkUrlControl"
></sh-input-text>

<div class="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
    @if (menu().hasLink) {
        <sh-button
            class="block w-full sm:w-auto"
            data-testid="global-editor-menu-button-remove-link"
            [label]="'common.editor.remove-link' | translate"
            color="secondary"
            size="max-content"
            (click)="removeLink($event)"
        ></sh-button>
    }

    <sh-button
        class="block w-full sm:w-auto"
        data-testid="global-editor-menu-button-apply-link"
        [label]="'common.editor.insert-link' | translate"
        size="max-content"
        [disabled]="!canApplyLink()"
        (click)="applyLink($event)"
    ></sh-button>
</div>
